import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../lib/api.ts';
import { useStore } from '../lib/store.ts';

export function useZoneCalc() {
  const { t } = useTranslation();
  const setFTP = useStore((s) => s.setFTP);
  const addToast = useStore((s) => s.addToast);

  return useMutation({
    mutationFn: (ftp: number) => api.zoneCalc({ ftp }),
    onSuccess: (data) => setFTP(data.ftp),
    onError: () => addToast({ message: t('errors.zoneCalcFailed'), type: 'error' }),
  });
}
